module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "repeater-wrap"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    class: _vm.repeaterClass()
  }, [_c('button', {
    class: _vm.repeaterInputClass(),
    on: {
      "click": _vm.openPanel
    }
  }, [_c('span', {
    staticClass: "repeater__total"
  }, [_vm._v(_vm._s(_vm.getDisplayValue))])]), _vm._v(" "), _c('Icon', {
    attrs: {
      "icon": "repeater-list"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bc06e78!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Repeater.vue
// module id = 320
// module chunks = 0